export default function AreaGradient({
  id, colour, startOpacity, endOpacity
}:Readonly<{
  id: string; colour: string; startOpacity: number; endOpacity: number;
}>) {
  return (
    <defs>
      <linearGradient id={id} x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor={colour} stopOpacity={startOpacity} />
        <stop offset="100%" stopColor={colour} stopOpacity={endOpacity} />
      </linearGradient>
    </defs>
  );
}
